import { ContentStore } from '@/entities/feed-block/model/content-store'
import { UserStore } from '@/entities/user'
import { IUser } from '@/entities/user/model/types'
import { contractRead, DEFAULT_PREC, getSplitTransaction, parseAmount } from '@/shared/lib'
import useNotifier, { createCalls } from '@/shared/lib/use-notifier'
import { LangStore } from '@/shared/model/store'
import { ContractsStore } from '@/shared/model/store/contracts-store'
import { Button, Label, Switch } from '@/shared/ui'
import NpoModal from '@/widgets/post-editor/ui/npo-modal'
import { useState } from 'react'

type Props = {
	cid: string
	npoOnly?: boolean
}

const NftBuy = ({ cid, npoOnly }: Props) => {
	const { contracts } = ContractsStore()
	const { langPack } = LangStore()
	const [isNko, setIsNko] = useState(!!npoOnly)
	const { user_npos } = UserStore()
	const { activePost } = ContentStore()

	const { writeContract, writeContractMulticall, isLoading } = useNotifier({})

	const owner_address = activePost?.nft?.owner?.address as `0x${string}`
	const hasNpo =
		user_npos && user_npos?.length > 0 && user_npos?.filter((el: IUser) => el.address !== owner_address).length > 0

	const nkoBuy = async (npo_address: `0x${string}`) => {
		const currentPrice = await contractRead('NFTMarketplace', 'getPrice', [cid])
		const converted = Number(currentPrice) / DEFAULT_PREC
		const calls = createCalls([
			{
				address: contracts.SavvaToken.address,
				abi: contracts.SavvaToken.abi,
				functionName: 'approve',
				args: [contracts!.NFTMarketplace.address, parseAmount(converted)]
			},
			{
				address: contracts.NFTMarketplace.address,
				abi: contracts.NFTMarketplace.abi,
				functionName: 'buy',
				args: [cid, parseAmount(converted)]
			}
		])

		writeContractMulticall(npo_address, calls)
	}

	const buy = async () => {
		const newPrice = await contractRead('NFTMarketplace', 'getPrice', [cid])
		const { message, v, r, s } = await getSplitTransaction({
			token: 'SAVVA',
			spender: contracts!.NFTMarketplace.address,
			amount: Number(newPrice) / DEFAULT_PREC
		})

		writeContract({
			address: contracts.NFTMarketplace.address,
			abi: contracts.NFTMarketplace.abi,
			functionName: 'buyWithPermit',
			args: [cid, message.value, message.deadline, v, r, s]
		})
	}

	return (
		<div>
			{isNko ? (
				<NpoModal reg={nkoBuy} isLoading={isLoading} button={langPack('nft.buy')} disabled={[owner_address]}>
					<Button variant='orange' className='w-full text-white' size='sm' loading={isLoading}>
						{`${langPack('nft.buy')} ${langPack('npo.onBehalfOfNpo')}`}
					</Button>
				</NpoModal>
			) : (
				<Button variant='orange' className='w-full text-white' size='sm' onClick={buy} loading={isLoading}>
					{langPack('nft.buy')}
				</Button>
			)}
			{hasNpo && !npoOnly && (
				<div className='mt-5 flex w-full items-center justify-between'>
					<Label>{`${langPack('nft.buy')} ${langPack('npo.onBehalfOfNpo')}`}</Label>
					<Switch checked={isNko} onCheckedChange={setIsNko} />
				</div>
			)}
		</div>
	)
}

export default NftBuy
